module.exports = __webpack_public_path__ + "static/img/banner003.da3e8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner003.png
// module id = wicm
// module chunks = 15